import Image from "next/image"
import Link from "@/components/Link"
import { AspectRatio } from "@/components/ui/aspect-ratio"
import { getImagePath } from "@/lib/helpers/imageHelpers"
import { Video, Timer, Folder, Users } from "lucide-react"
import { TreeDataConverter } from "@/lib/helpers/course/treeData"
import { Badge } from "./Badge"
import { LearningDetails } from "./LearningDetails"
import { LEARNING_MODES } from "./types"
import type { ICourseGridCardProps } from "./types"
import { cn } from "@/lib/utils"
import { ProxyImage } from "@/components/ui/ProxyImage"
export const CourseGridCard = ({
	data: courseData,
	contentPrice,
	discountContentCard,
	priority = false,
	showDetail = true,
}: ICourseGridCardProps) => (
	<Link className="block w-full" href={`/course/${courseData.slug}`}>
		<div className="mx-auto overflow-hidden rounded-lg border border-gray-200 bg-white shadow-md transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-lg md:max-w-sm">
			<div className="relative w-full">
				<AspectRatio ratio={16 / 9} className="bg-muted">
					<ProxyImage
						src={getImagePath(courseData, "course", "sm", true)}
						alt={courseData.name}
						width={346}
						height={195}
						className={cn(
							"h-full w-full object-cover transition-opacity duration-300",
							!priority && "blur-up"
						)}
					// priority={priority}
					// loading={priority ? "eager" : "lazy"}
					// fetchPriority={priority ? "high" : "auto"}
					// sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
					// quality={priority ? 85 : 75}
					// placeholder="blur"
					// blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx0fHRsdHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR3/2wBDAR0XFyAeIRshGxsdIR0hHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR3/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
					/>
					<div
						className={`absolute top-0 right-0 rounded-bl-lg px-2 py-1 text-sm text-white ${contentPrice === "Đã mua" ? "bg-[#2e7d32]" : "bg-[#d32f2f]"}`}
					>
						{contentPrice}
					</div>
					{discountContentCard}
				</AspectRatio>
			</div>
			<div className="px-2 py-3">
				<div className="h-[50px]">
					<h3 className="line-clamp-2 font-semibold text-gray-800 text-md">
						{courseData.name}
					</h3>
				</div>
				<div className="mt-2 flex items-center">
					<div className="w-full text-gray-600 text-sm">
						<div className="flex items-center justify-between">
							<p className="font-semibold">{courseData.lecturer_name}</p>
							<div className="flex items-center">
								{showDetail && (
									<span className="flex items-center gap-1 text-gray-600 text-xs">
										{courseData.number_of_students + courseData.count_user} học viên
									</span>
								)}
							</div>
						</div>
					</div>
				</div>
				{showDetail && (
					<div className="mt-1 flex flex-wrap items-center gap-1">
						<Badge
							icon={<Video className="h-3 w-3" />}
							text={
								courseData.learning_mode === LEARNING_MODES.GOOGLE_MEET
									? "Google Meet"
									: courseData.learning_mode
							}
						/>
						<Badge
							icon={<Timer className="h-3 w-3" />}
							text={TreeDataConverter.convertSecondsToHours(courseData.total_duration)}
							variant="green"
						/>
						<Badge
							icon={<Folder className="h-3 w-3" />}
							text={`${courseData.total_chapter} chương`}
							variant="purple"
						/>
						<LearningDetails mode={courseData.learning_mode} />
					</div>
				)}
			</div>
		</div>
	</Link>
) 